import api from 'lib/api';

const farmerOnboardingService = {
  importFarmers: async (formData) => {
    try {
      const response = await api.importFarmers(formData);
      return response;
    } catch (error) {
      console.error('Error in importFarmers:', error);
      throw error;
    }
  },
};

export default farmerOnboardingService;
